import React, { Component } from 'react'
import Popover from 'material-ui/Popover'
import FlatButton from 'material-ui/FlatButton'
import { FormattedMessage } from 'react-intl'
import { DropDownEmail, DropDownUserName, Footer } from './styles'
import images from '../../../config/images'
import { Redirect } from 'react-router-dom'
import {  getImageURI, getToken } from '../../../lib'

class ProfileDropDown extends Component {
  handleLogout = () => {
    const token = getToken()
    sessionStorage.removeItem('authToken')
    localStorage.removeItem('authToken')
    this.props.recieveLoginstatus(false, {})
    this.props.shouldRedirectUser(false)
    this.props.logoutUser(token)
  }

  render() {
    const {
      userid,
      popOverOpen,
      anchorEl,
      anchorOrigin,
      targetOrigin,
      onRequestClose,
      email,
      accountType,
      name,
      upgradeUser,
      newSeminarUpgradeModal,
      location
    } = this.props
    const imageURI = getImageURI(userid, images.profilePic)
    if (this.props.logoutSuccess) {
      return (
        <Redirect to={'/login'}/>
      )
    }
    return (
      <Popover
        open={popOverOpen}
        anchorEl={anchorEl}
        anchorOrigin={anchorOrigin}
        targetOrigin={targetOrigin}
        onRequestClose={onRequestClose}
        useLayerForClickAway={false}
        zDepth={1}
        className='popover'
        style={{overflowY: 'none', border: 3}}>
        <div className='pa3 flex'>
          <div>
            <img
              style={{height: 100, width: 100, border: '1px solid #d9d9d9'}}
              src={imageURI}
              alt='profile'/>
          </div>
          <div className='pl3 flex justify-around flex-column'>
            <DropDownUserName>
              {name}
            </DropDownUserName>
            <DropDownEmail>
              {email}
            </DropDownEmail>
            <div>
            </div>
          </div>
        </div>
        <div>
          <Footer className='pa3 flex justify-between'>
            <FlatButton
              label={<FormattedMessage id='loggedInNavigation.logout'/>}
              onTouchTap={this.handleLogout}
              backgroundColor='#FFFFFF'
              labelStyle={{color: '#4688F1'}}/>
          </Footer>
        </div>
      </Popover>
    )
  }
}

export default ProfileDropDown



// WEBPACK FOOTER //
// src/components/Profile/NavBarProfile/ProfileDropDown.js